
import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { SessionService } from "@services/session.service";
import { map, filter, take } from 'rxjs';

export const authGuard: CanActivateFn = (route, state) => {
  const sesion = inject(SessionService);
  const router = inject(Router);
  
  const funcionalidadPermitida = route.data?.['funcionalidad'] as number;

  return sesion.sesion$.pipe(
    take(1),
    map((usuario) => {
      if (!usuario) {
        return router.createUrlTree(['/']); // redirigir al inicio
      }
      sesion.hasFunctionality(funcionalidadPermitida)
        ? true
        : router.createUrlTree(['/unauthorized'])
    })
  );
};

export const authGuardAction: CanActivateFn = (route, state) => {
  const sesion = inject(SessionService);
  const router = inject(Router);
  
  const funcionalidadPermitida = Number(route.data?.['funcionalidad']);
  const accionPermitida = Number(route.data?.['accion']);

  return sesion.sesion$.pipe(
    filter((u) => u !== null), // espera a que haya sesión
    take(1),
    map((usuario) =>
      sesion.hasAction(funcionalidadPermitida, accionPermitida)
        ? true
        : router.createUrlTree(['/unauthorized'])
    )
  );
};
